module.exports = __webpack_public_path__ + "static/media/tableau-logo.0cdcf2ee.svg";